import { buildBindable } from '@monofe/di';
import { TYPES as UTIL_TYPES, injectFeatureQuery, injectMimeType } from '@monofe/util';
import tourDataResolver from './tourDataResolver';
import { TYPES, bindTourDataResolver, injectTourDataResolver, unbindTourDataResolver } from './tourDataResolver.if';

function _build(container) {
  const query = injectFeatureQuery(container);
  const mimeType = injectMimeType(container);
  const result = tourDataResolver(query, mimeType);
  return Object.freeze(result);
}

export default buildBindable({
  id: TYPES.ITourDataResolver,
  dependencies: [UTIL_TYPES.IFeatureQuery, UTIL_TYPES.IMimeType],
  bind: bindTourDataResolver,
  remove: unbindTourDataResolver,
  inject: injectTourDataResolver,
  build: container => Promise.resolve(_build(container))
});